/**
 * Skeleton blocks for a Home region while its data loads (specs/home-page §7 Loading row).
 */

import React, { useMemo } from 'react';
import { View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { getHomeRegionStateStyles } from './HomeRegionState.styles';

export interface HomeRegionSkeletonProps {
  /** Number of placeholder rows (`row` variant). */
  rows?: number;
  /** `row` = list rows inside a card; `tile` = one tile-sized block. */
  variant?: 'row' | 'tile';
  testID?: string;
}

export const HomeRegionSkeleton: React.FC<HomeRegionSkeletonProps> = ({
  rows = 3,
  variant = 'row',
  testID,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => getHomeRegionStateStyles(theme), [theme]);
  const keys = useMemo(() => Array.from({ length: rows }, (_, i) => `skeleton-${i}`), [rows]);

  if (variant === 'tile') {
    return <View style={styles.skeletonTile} testID={testID} />;
  }

  return (
    <View style={styles.skeletonStack} testID={testID}>
      {keys.map((key) => (
        <View key={key} style={styles.skeletonRow} />
      ))}
    </View>
  );
};
